var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17350",
    d: "M0 22.694a1.5 1.5 0 012.515-1.1l5.985 5.5V1.5a1.5 1.5 0 013 0v25.586l5.985-5.5a1.5 1.5 0 112.029 2.208l-8.5 7.806a1.49 1.49 0 01-.925.39 1.544 1.544 0 01-.28-.011 1.5 1.5 0 01-.725-.3 1.2 1.2 0 01-.1-.087l-8.491-7.8a1.493 1.493 0 01-.485-1.1",
    fill: "currentcolor"
  })));
}
export default SvgArrowDown;